module.exports = __webpack_public_path__ + "static/media/selectedCustomersIcon.1051c0f9.png";